import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  // 学员考勤
  function goClassGroup(onlineClass) {
    router.push({
      path: "attendanceManage/attendance",
      query: { classId: onlineClass.uuid, classStatus: onlineClass.classStatus },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    const dealConf = onlineClass.childNum > 0 ? [
      ["icon_xiaoban_data", "小班数据", () => {
        router.push({
          path: "attendanceManage/smallClassData",
          query: { classId: onlineClass.uuid, classStatus: onlineClass.classStatus },
        });
      }, ""],
    ] : [
      ["icon_kaoqin_icon", "学员考勤", () => goClassGroup(onlineClass), ""]
    ]

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "班级名称",
      minWidth: "220",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          size="small"
          type="text"
          onClick={() => {
            router.push({
              path: "/onlineClass/detail",
              query: { id: vo.row.uuid }
            });
          }}
        >
          {vo.row.className}
        </el-button>
      )
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "承办单位",
      prop: "undertakeUnit",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "班级类型",
      width: "150",
      prop: "trainTypeName",
      showOverflowTooltip: true,
    },
    {
      label: "办班级别",
      prop: "classLevelName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "班级状态",
      prop: "classStatusName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "开始时间",
      prop: "trainStartTime",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "结束时间",
      prop: "trainEndTime",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "学制(天)",
      prop: "trainDays",
      width: "90",
      showOverflowTooltip: true,
    },
    {
      label: "报名情况",
      prop: "enrollSituation",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "班主任",
      prop: "headmaster",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      fixed: "right",
      width: "80",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
